/**
 * As we are using hash based navigation, hack fix
 * to highlight the current selected menu
 *
 * Requires jQuery
 *
 * @param  slug
 */
function menuFix( slug ) {
	const $ = jQuery;

	const menuRoot = $( '#toplevel_page_' + slug );
	const currentUrl = window.location.href;
	const currentPath = currentUrl.substr( currentUrl.indexOf( 'admin.php' ) );

	menuRoot.on( 'click', 'a', function () {
		const self = $( this );

		$( 'ul.wp-submenu li', menuRoot ).removeClass( 'current' );

		if ( self.hasClass( 'wp-has-submenu' ) ) {
			$( 'li.wp-first-item', menuRoot ).addClass( 'current' );
		} else {
			self.parents( 'li' ).addClass( 'current' );
		}
	} );

	$( 'ul.wp-submenu a', menuRoot ).each( function ( index, el ) {
		if ( $( el ).attr( 'href' ) === currentPath ) {
			$( el ).parent().addClass( 'current' );
		}
	} );
}

export default menuFix;
